Monitoring.Views ||= {}

class Monitoring.Views.TicketConditionEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/ticket_condition_edit"]

  events:
    'change #condition-previous-ticket-status': 'onChangePreviousStatus'
    'change #condition-present-ticket-status': 'onChangePresentStatus'
    'change #operator-assigned-check': 'onCheckAssignedOperator'
    'change #group-assigned-check': 'onCheckAssignedGroup'
    'change #new-ticket-check': 'onCheckNewTicket'
    'change #prioritized-ticket-check': 'onCheckPrioritizedTicket'
    'click #condition-group-assigned': 'onConditionGroupAssigned'
    'click #condition-group-not-assigned': 'onConditionGroupNotAssigned'
    'click #condition-operator-assigned': 'onConditionOperatorAssigned'
    'click #condition-operator-not-assigned': 'onConditionOperatorNotAssigned'
    'click #condition-new-ticket': 'onConditionNewTicket'
    'click #condition-not-new-ticket': 'onConditionNotNewTicket'
    'click #condition-prioritized-ticket': 'onConditionPrioritizedTicket'
    'click #condition-not-prioritized-ticket': 'onConditionNotPrioritizedTicket'
    'change #selected-operator': 'onChangeSelectedOperator'

  initialize: (@options = {}) ->
    @ticketCondition      = @options.ticketCondition
    @availableTags        = @options.availableTags
    @availableLabels     = @options.availableGroups
    @availableTicketStatuses  = @acceptedStatuses(@options.availableTicketStatuses)
    @availableOperators  =  @options.availableOperators || []
    @editView             = @options.editView

    @_initializeIntelligentTagsFilterView()
    @_initializeIntelligentLabelsFilterView()

  render: =>
    @$el.html(@template(@))
    @initializeChosen()
    @_renderLabelsFilter()
    @_renderTagsFilter()
    @

  _initializeIntelligentTagsFilterView: ->
    @intelligentTagsFilterView = new Customer.ResponseTemplateTagsFilterView
      filter: @ticketCondition.intelligent_filter.intelligent_tags
      possibleTags: @availableTags
      hiddenTags: []
      useCustomValues: true

  _initializeIntelligentLabelsFilterView: ->
    @intelligentLabelsFilterView = new Customer.ResponseTemplateGroupsFilterView
      filter: @ticketCondition.intelligent_filter
      groups: @availableLabels
      useCustomValues: true

  _renderTagsFilter: ->
    @$('.tags-filter-container').html(@intelligentTagsFilterView.render().el)

  _renderLabelsFilter: ->
    @$('.labels-filter-container').html(@intelligentLabelsFilterView.render().el)

  getCondition: ->
    @ticketCondition['intelligent_filter'] =
      intelligent_groups: @intelligentLabelsFilterView.getIntelligentGroups()
      intelligent_tags: @intelligentTagsFilterView.getIntelligentTags()
    @ticketCondition

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({
      width: '360px',
      enable_split_word_search: true,
      search_contains: true
    });

  acceptedStatuses: (statusList) ->
    statusList.filter (status) -> status != 'Reopen'

  removeChosenOption: (propertyName, value) =>
    $("#condition-#{propertyName} option[value=#{value}]").prop('selected', false).trigger('chosen:updated')

  onChangePreviousStatus: (evt) ->
    @onChangeMultiselectProperty('previous_ticket_status')

  onChangePresentStatus: (evt) ->
    @onChangeMultiselectProperty('present_ticket_status')

  onChangeMultiselectProperty: (propertyName, isInteger = false) ->
    selectedOptions = @$el.find("#condition-#{propertyName.replace(/_/g, '-')} option:selected")
    enteredProperties = _.map(selectedOptions, (opt) -> if isInteger then parseInt(opt.value) else opt.value)
    @ticketCondition[propertyName] = enteredProperties

  onCheckAssignedOperator: ->
    @toggleCheckedConditions('#operator-assigned', 'assigned_to_operator', '#condition-operator-assigned', '#condition-operator-not-assigned')
    @_hideOrShowAssignedOperator()

  onCheckAssignedGroup: ->
    @toggleCheckedConditions('#group-assigned', 'assigned_to_user_group', '#condition-group-assigned', '#condition-group-not-assigned')

  onCheckNewTicket: ->
    @toggleCheckedConditions('#new-ticket', 'new_ticket', '#condition-new-ticket', '#condition-not-new-ticket')

  onCheckPrioritizedTicket: ->
    @toggleCheckedConditions('#prioritized-ticket', 'prioritized_ticket', '#condition-prioritized-ticket', '#condition-not-prioritized-ticket')

  toggleCheckedConditions: (conditionElem, conditionName, positiveButton, negativeButton) ->
    checked = $("#{conditionElem}-check").prop('checked')
    $("#{conditionElem}-options").toggleClass('active', checked)
    value = if checked then $("#{conditionElem}-options button.active").val() else ''
    unless checked
      $(positiveButton).removeClass('active')
      $(negativeButton).addClass('active')
    @ticketCondition[conditionName] = value

  onChangeSelectedOperator: (event) =>
    operator = $(event.currentTarget).find('option:selected').val();
    @ticketCondition['operator_id'] = operator

  onConditionGroupAssigned: ->
    @toggleActiveOptions('#condition-group-assigned', '#condition-group-not-assigned')
    @ticketCondition.assigned_to_user_group = 'assigned'

  onConditionGroupNotAssigned: ->
    @toggleActiveOptions('#condition-group-not-assigned', '#condition-group-assigned')
    @ticketCondition.assigned_to_user_group = 'not-assigned'

  onConditionOperatorAssigned: ->
    @toggleActiveOptions('#condition-operator-assigned', '#condition-operator-not-assigned')
    @ticketCondition.assigned_to_operator = 'assigned'
    @_hideOrShowAssignedOperator()

  onConditionOperatorNotAssigned: ->
    @toggleActiveOptions('#condition-operator-not-assigned', '#condition-operator-assigned')
    @ticketCondition.assigned_to_operator = 'not-assigned'
    @_hideOrShowAssignedOperator()

  onConditionNewTicket: ->
    @toggleActiveOptions('#condition-new-ticket', '#condition-not-new-ticket')
    @ticketCondition.new_ticket = 'new'

  onConditionNotNewTicket: ->
    @toggleActiveOptions('#condition-not-new-ticket', '#condition-new-ticket')
    @ticketCondition.new_ticket = 'not-new'

  onConditionPrioritizedTicket: ->
    @toggleActiveOptions('#condition-prioritized-ticket', '#condition-not-prioritized-ticket')
    @ticketCondition.prioritized_ticket = 'prioritized'

  onConditionNotPrioritizedTicket: ->
    @toggleActiveOptions('#condition-not-prioritized-ticket', '#condition-prioritized-ticket')
    @ticketCondition.prioritized_ticket = 'not-prioritized'

  _hideOrShowAssignedOperator: ->
    checked = $("#operator-assigned-check").prop('checked')
    if checked && @ticketCondition.assigned_to_operator == 'assigned'
      $('#operator-assigned-select').removeClass('hide')
    else
      $('#operator-assigned-select').addClass('hide')
      @ticketCondition['operator_id'] = ''

  toggleActiveOptions: (active, notActive) ->
    @$el.find(active).addClass('active')
    @$el.find(notActive).removeClass('active')

  allMandatoryFieldsAreFilled: =>
    true
